import React from 'react';
import type { ThemeProps } from 'styled-components';
import type { ColorPickerColorType, ThemeType } from '../../util/types';
import styled, { css } from 'styled-components';
import { getPolishedColors } from '../../util/styled';
import { COLOR_PICKER_COLORS } from '../../util/vars';

type Props = {
  $color: ColorPickerColorType,
  isOutline?: boolean,
};

const getColors = (props: ThemeProps<ThemeType> & Props) => {
  const colors = getPolishedColors(props);

  if (props.isOutline) {
    return css`
      text-overflow: ellipsis;
      background: transparent;
      border: 2px solid ${colors.main.color};
    `;
  }
  return css`
    text-overflow: ellipsis;
    background: ${colors.main.color};
    color: ${colors.main.readable};
    border: 2px solid ${colors.main.color};
  `;
};

const TagStyled = styled('div')<Props>`
  ${(props) => getColors(props)}
  max-width: 12rem;
`;

export interface TagProps  {
  color: ColorPickerColorType | keyof typeof COLOR_PICKER_COLORS;
  children?: string | null;
  isOutline?: boolean;
  isCircle?: boolean;
  className?: string;
  onClick?: React.MouseEventHandler;
}

const Tag = ({ color, children = null, isOutline = false, isCircle = false, className = '', ...other }: TagProps): JSX.Element  => {
  return (
    <TagStyled
      $color={typeof color === 'number' ? COLOR_PICKER_COLORS[color] : color}
      isOutline={isOutline}
      className={`${isCircle ? 'rounded-full' : 'rounded'} p-3 text-center whitespace-nowrap overflow-hidden ${className}`}
      title={children as string}
      {...other}
    >{children}</TagStyled>
  );
};

Tag.displayName = 'Tag';

export default Tag;
